import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const TwoColumnContent = ({ title, items }) => {
  return (
    <section className='two-column-content' id="lifestyle-culture">
      <Fade bottom distance='40px'>
        <div className='two-column-content__inner'>
          { title && <h4>{parse(title)}</h4> }
          <div className='two-column-content__items'>
            { items && items.map((el, i) => (
              <div className='two-column-content__item' key={i}>
                { el.image && <GatsbyImage image={getImage(el.image.localFile)} alt={el.image.altText} /> }
                { el.content && <p>{parse(el.content)}</p> }
              </div>
            )) }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default TwoColumnContent
